import { useEffect, useState } from 'react'
import { Capacitor } from '@capacitor/core'
import { App as CapacitorApp } from '@capacitor/app'

/**
 * Which build am I actually running? Shown on the Profile tab and the
 * Help screen. iOS shows the App Store marketing version + native
 * build number (from the shell binary); both platforms show the WEB
 * bundle's git SHA — the only identity the continuously-deployed web
 * app has. Web carries the same marketing version as the iOS train it
 * ships with (read from the pbxproj at build time), per the synced
 * release standard: web publishes only alongside an iOS submission.
 */
export function VersionStamp() {
  const [native, setNative] = useState<string | null>(null)
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return
    CapacitorApp.getInfo()
      .then(i => setNative(`iOS ${i.version} (${i.build})`))
      .catch(() => { /* stamp just omits the native part */ })
  }, [])
  return (
    <p className="text-center text-xs text-brand-muted pb-2">
      {native ?? `Web v${__APP_VERSION__}`} · build {__BUILD_SHA__} · {__BUILD_DATE__}
    </p>
  )
}
